import {
  Services,
  BrowserServices,
  Endpoints,
  EndpointSM,
  Instances,
  MobileInstances,
  Database,
  DatabaseService,
  OAPTimeInfo,
  ServicesForTeam,
  ServiceLanguage,
  ServiceInstances,
  LabeledValues,
  SessionDetails,
  databaseQueryDetails,
  databaseAvgData,
  eventQueryDetails,
  InstancesByServiceId,
  RangeEndpoints,
  bucketDetails,
  instanceByMetaProperty,
  QueryPerformanceInfo,
  ServiceInstancesInfo,
  InstanceByMeta,
  getServiceForTeamWithTotalCount,
  serviceInstancesWithTotalCount,
  instancesWithTotal
} from '../fragments/option';

export const queryServices = `query getServiceForTeam(${ServicesForTeam.variable}) {${ServicesForTeam.query}}`;

export const queryServiceInstances = `query getServiceInstances(${ServiceInstances.variable}) {${ServiceInstances.query}}`;

export const queryBrowserServices = `query queryBrowserServices(${BrowserServices.variable}) {${BrowserServices.query}}`;

export const queryDatabases = `query queryDatabases(${Database.variable}) {${Database.query}}`;

export const queryDatabaseService = `query queryDatabaseService(${DatabaseService.variable}) {${DatabaseService.query}}`;

export const queryEndpoints = `query queryEndpoints(${Endpoints.variable}) {${Endpoints.query}}`;

export const queryRangeEndpoints = `query queryEndpoints(${RangeEndpoints.variable}) {${RangeEndpoints.query}}`;

export const querySMEndpoint = `query queryEndpoints(${EndpointSM.variable}) {${EndpointSM.query}}`;

export const queryServiceInstanceByMeta = `query getServiceInstancesByMetaProperties(${InstanceByMeta.variable}) {${InstanceByMeta.query}}`;

export const queryInstances = `query queryInstances(${Instances.variable}) {${Instances.query}}`;

export const queryInstancesByService = `query queryInstances(${InstancesByServiceId.variable}) {${InstancesByServiceId.query}}`;

export const queryOAPTimeInfo = `query queryOAPTimeInfo {${OAPTimeInfo.query}}`;

export const queryServiceLanguage = `query queryServiceLanguage(${ServiceLanguage.variable}) {${ServiceLanguage.query}}`;

export const queryInstacesForMobile = `query queryInstances(${MobileInstances.variable}) {${MobileInstances.query}}`;

export const queryLabledValues = `query  readLabeledMetricsLatestValue(${LabeledValues.variable}) {${LabeledValues.query}}`;

export const querySessionDetails = `query readLabeledMetricsLatestValue(${SessionDetails.variable}) {${SessionDetails.query}}`;

export const queryDatabaseDetails = `query readAllSampledRecords(${databaseQueryDetails.variable}) {${databaseQueryDetails.query}}`;

export const queryEventDetails = `query dbmEventTable(${eventQueryDetails.variable}) {${ eventQueryDetails.query}}`

export const queryBucketDetails = `query getServiceInstancesByMetaProperties(${bucketDetails.variable}) {${bucketDetails.query}}`;

export const queryInstancesByMetaProperty = `query getServiceInstancesByMetaProperties(${instanceByMetaProperty.variable}) {${instanceByMetaProperty.query}}`;

export const queryPerformaceDetails = `query readAllSampledRecordsByTimeBucket(${QueryPerformanceInfo.variable}) {${QueryPerformanceInfo.query}}`;

export const queryInstancesInfo = `query getServiceInstances(${ServiceInstancesInfo.variable}) {${ServiceInstancesInfo.query}}`;

export const queryServicesWithTotalCount = `query getServiceForTeamWithTotalCount(${getServiceForTeamWithTotalCount.variable}) {${getServiceForTeamWithTotalCount.query}}`

export const queryAvgData = `query readMetricsValue(${databaseAvgData.variable}) {${databaseAvgData.query}}`

export const queryServiceInstancesWithTotalCount = `query getServiceInstancesWithTotalCount(${serviceInstancesWithTotalCount.variable}) {${serviceInstancesWithTotalCount.query}}`;

export const queryInstancesByMetaPropertyWithTotal = `query getServiceInstancesByMetaPropertiesWithTotal(${instancesWithTotal.variable}) {${instancesWithTotal.query}}`;
